// gimme: conversations-thread-view 06/30/2021 cfef6b9a8b3badc65b082ffd722b737fa8d16bdf
'use es6';

import { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FileButton } from 'foundations-components/transitional/components/FileButton';
import { ALLOWED_FILE_TYPES } from 'conversations-internal-schema/file-metadata/constants/allowedFileTypes';
import { useEditorCapability } from 'composer-data/channel-capabilities/public/hooks';
import { jsx as _jsx } from "react/jsx-runtime";
const UploadFileButton = /*#__PURE__*/memo(({
  onSelectFiles
}) => {
  const handleChange = useCallback(event => {
    const {
      files
    } = event.target;
    if (!files || files.length === 0) return;
    onSelectFiles(files);
  }, [onSelectFiles]);
  const allowedFileAttachmentMimeTypes = useEditorCapability('allowedFileAttachmentMimeTypes');
  return /*#__PURE__*/_jsx(FileButton, {
    accept: allowedFileAttachmentMimeTypes || ALLOWED_FILE_TYPES,
    multiple: true,
    onChange: handleChange,
    "data-test-id": "upload-new-file-button",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "composer-ui.prosemirror.plugins.attachments.upload-label"
    })
  });
});
UploadFileButton.displayName = 'UploadFileButton';
UploadFileButton.propTypes = {
  onSelectFiles: PropTypes.func.isRequired
};
export default UploadFileButton;